// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__2h8O0","filesListContainer":"PosDisputesFiles_filesListContainer__3rUO9","filesButton":"PosDisputesFiles_filesButton__2PsSH"};